import { ChakraProps, Image } from '@chakra-ui/react';
import { diLogos } from '@acp/core-ui/assets';

type DiLogoProps = {
    variant: LogoVariant;
} & ChakraProps & Omit<ChakraProps, 'image'>;

export type LogoVariant =
    | 'stackedRGBWhite'
    | 'stackedRGB'
    | 'horizontalRGB'
    | 'horizontalRGBWhite'
    | 'horizontalCharcoal'
    | 'stackedCharcoal'
    | 'stackedWhite'
    | 'markOrange'
    | 'horizontalWhite'
    | 'markWhite';

const logoMap: Record<LogoVariant, string> = {
    stackedRGBWhite: diLogos.stackedRGBWhite,
    stackedRGB: diLogos.stackedRGB,
    horizontalRGB: diLogos.horizontalRGB,
    horizontalRGBWhite: diLogos.horizontalRGBWhite,
    horizontalCharcoal: diLogos.horizontalCharcoal,
    stackedCharcoal: diLogos.stackedCharcoal,
    stackedWhite: diLogos.stackedWhite,
    horizontalWhite: diLogos.horizontalWhite,
    markOrange: diLogos.markOrange,
    markWhite: diLogos.markWhite,
};

export function DiLogo({ variant = 'horizontalRGB', ...props }: DiLogoProps) {
    return (
        <Image
            data-testid="di-logo"
            src={logoMap[variant]}
            alt="Detector Inspector Logo"
            fit="contain"
            {...props}
        />
    );
}
